<template>
  <b-card no-body>
    <b-card-body class="d-flex justify-content-between align-items-center">
      <b-avatar
        :variant="`light-${color}`"
        size="45"
      >
        <feather-icon
          size="21"
          :icon="icon"
        />
      </b-avatar>
      <div class="truncate">
        <h3 class="mb-25 font-weight-bolder text-right">
          {{ statisticTitle }}
        </h3>
        <div class="text-right">{{ $t('Total Product') }}</div>
        <h2 class="mb-25 font-weight-bolder text-right">
          {{ statistic | numberWithCommas }}
        </h2>
      </div>

    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardBody,
    BAvatar,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    statistic: {
      type: [Number, String],
      required: true,
    },
    statisticTitle: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
}
</script>
